export default {
  noAlarms: 'Keine aktiven Störungen gefunden.',
  activeAlarms: 'Aktive Störungen',
  acknowledgeAll: 'Alle bestätigen',
  enableNotificationsForNewAlarms: 'Bei Störungen benachrichtigen',
  enableNotificationsForNewAlarmsTooltip: 'Bei einer neuen Störung eine Browser-Benachrichtigung anzeigen.',
  newAlarmNotificationTitle: 'Neue Störung',
  notificationsPermissionDeniedTooltip: 'Sie haben Benachrichtigungen in Ihrem Browser nicht erlaubt.',
  notificationsPermissionUnsupportedTooltip: 'Ihr Browser unterstutzt keine Benachrichtigungen.',
};
